// extracted by mini-css-extract-plugin
module.exports = {"markdowncontent":"ContactPersonEventView_markdowncontent__3ng0h"};